<div class="container-fluid">
  <div class="row">
    <div class="w-100 mt-5 text-white text-center">
      <h2>Page inexistante</h2>
      <div>
        La page demandée n'a pas été trouvée!
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="w-100 text-center">
      <button mat-flat-button color="primary" [routerLink]="['/']" routerLinkActive="router-link-active">
        <mat-icon>home</mat-icon> Accueil
      </button>
    </div>
  </div>
</div>